
const SEL_MODAL = '[data-modal]';
const SEL_MODAL_LAUNCH = '[data-modal-launch]';
const SEL_MODAL_CLOSE = '[data-modal-close]';
const ATTR_MODAL_LAUNCH = 'data-modal-launch';
const CLASS_OPEN = 'is-open';

import { CLASS_SCROLL_DISABLED } from '../tools/constants/classes';

const modalContainers = document.querySelectorAll<HTMLElement>(SEL_MODAL);
const modalLaunchButtons = document.querySelectorAll<HTMLButtonElement>(SEL_MODAL_LAUNCH);
const modalCloseButtons = document.querySelectorAll<HTMLButtonElement>(SEL_MODAL_CLOSE);

// Add Open Modal Event Listner
modalLaunchButtons.forEach(button => {
  button.addEventListener('click', (e) => {
    openModal(e);
  });
});

// Add Close Modal Event Listner
modalCloseButtons.forEach(button => {
  button.addEventListener('click', (e) => {
    closeModal(e);
  });
});

// Open Modal
function openModal(e: Event) {
  e.preventDefault();
  const ele = e.currentTarget as HTMLButtonElement;
  const modalId = ele.getAttribute(ATTR_MODAL_LAUNCH);
  modalContainers.forEach(modal => {
    if (modal.id === modalId) {
      modal.classList.add(CLASS_OPEN);
      document.body.classList.add(CLASS_SCROLL_DISABLED);
    }
  });
}

// CLose Modal
function closeModal(e: Event) {
  e.preventDefault();
  const ele = e.currentTarget as HTMLButtonElement;
  const modalParent = ele.closest(SEL_MODAL) as HTMLElement;
  if (!modalParent) return;
  modalParent.classList.remove(CLASS_OPEN);
  document.body.classList.remove(CLASS_SCROLL_DISABLED);
}